import { post, postForm } from '../../helpers/axiosWrapper';

export const saveMeterUpgradeDetails = async (url: string | undefined, context: any, data: any): Promise<any> => {
  return await post(`${url}/bulkupload/meter-upgrade-request`, { data }, context);
};
